import RenderUser from './RenderUser';

export default RenderUser;
